import React, { useEffect } from "react";
import logger from "services/logger";

type Props = {
  desc?: string;
  customErrorText?: React.ReactNode;
  errorMetadata?: any;
}

export const ServerError: React.FC<Props> = props => {
  // Side effect: must not run in render (re-renders would re-send to Appsignal)
  useEffect(() => {
    if (props.desc && !props.customErrorText) {
      logger.sendError(new Error(props.desc));
    }
  }, [props.desc, props.customErrorText]);

  if (props.customErrorText) {
    return <>{props.customErrorText}</>;
  }

  return (
    <div>
      <b>Error loading content.</b>
      <br />
      Please contact technical support at{" "}
      <a href="mailto:support@havenconnect.com">support@havenconnect.com</a>
    </div>
  );
};
